import React from "react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import classes from "./FuwDeviceHeicModal.module.scss"

const FuwDeviceHeicModal = props => {
  const {
    openConvertingHeicImagesModal,
    setOpenConvertingHeicImagesModal
  } = props

  const [t] = useTranslation()

  return (
    <Modal
      show={openConvertingHeicImagesModal}
      onHide={() => setOpenConvertingHeicImagesModal(false)}
      centered
    >
      <div className={classes["container"]}>
        <h4 className={classes["title"]}>
          {t("در_حال_تبدیل_فرمت_فایل_ها")}
        </h4>
      </div>
    </Modal>
  )
}

export default FuwDeviceHeicModal